import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface InitialTicket {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  InitializeTicketData?: any;
}

const initialState: InitialTicket = {
  isLoading: false,
  error: false,
  message: null,
  InitializeTicketData: [],
};

const GetInitialTicketSlice = createSlice({
  name: "initialTicket",
  initialState,
  reducers: {
    loadingInitialTicket: (state: InitialTicket, action: PayloadAction) => {
      state.isLoading = true;
    },
    setInitialTicket: (state: any, action: PayloadAction<InitialTicket>) => {
      return action.payload;
    },
    clearData: (state: InitialTicket, action: PayloadAction) => {
      state.error = false;
    },
  },
});

export const { loadingInitialTicket, setInitialTicket, clearData } =
  GetInitialTicketSlice.actions;

export default GetInitialTicketSlice.reducer;
